import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { SERVER_URL } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';
import { Color } from '../models/color';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@angular/common";
import * as i3 from "./auth.service";
import * as i4 from "@angular/platform-browser";
export let CONNECTION_SOCKET_TIMEOUT = 5e3;
export let MAX_ATTEMPTS_SOCKET_RECONNECT = 10;
export class ConfigService {
    constructor(http, document, authService, domSanitizer) {
        this.http = http;
        this.document = document;
        this.authService = authService;
        this.domSanitizer = domSanitizer;
        this.events = new Subject();
        this.companyLoaded = new Subject();
        this.commentCreatedSource = new Subject();
        this.reactionDeletedSource = new Subject();
        this.queryParams = {};
        this.userHasAlreadyPosted = false;
        this.groupsPlayer = [];
        this.commentCreated$ = this.commentCreatedSource.asObservable();
        this.reactionDeleted$ = this.reactionDeletedSource.asObservable();
        this.initialInfoLog();
        this.getInitialInfo();
        // this.loadCustomScripts();
        this.authService.onChangeQueryParams.subscribe((data) => {
            console.debug("onChangeQueryParams", data);
            this.setQueryParams();
        });
    }
    getCustomCss() {
        let customCss = '';
        if (this.company_info)
            customCss += `custom-${this.company_info.name}`;
        if (this.authService.player_initial_data) {
            customCss += ` custom-player-${this.authService.player_initial_data.id}`;
            if (this.authService.player_initial_data.level) {
                customCss += ` custom-level-${this.authService.player_initial_data.level.id}`;
            }
            if (this.authService.player_initial_data.groups) {
                for (let g of this.authService.player_initial_data.groups) {
                    customCss += ` custom-group-${g}`;
                }
            }
        }
        return customCss;
    }
    initialInfoLog() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            console.debug("initialInfoLog");
            let data = yield this.getLoadedCompany();
            console.debug("initialInfoLog", data);
        });
    }
    getLoadedCompany() {
        this.getEvents().subscribe((event) => {
            if (event.name != 'checkInfo')
                return;
            this.getInitialInfo(true);
        });
        return new Promise((resolve) => {
            this.companyLoaded.pipe(debounceTime(100)).subscribe(data => { return resolve(data); });
        });
    }
    getEvents() {
        return this.events.asObservable();
    }
    sendEvent(event_name, data = null) {
        return this.events.next({ 'name': event_name, 'data': data });
    }
    //Function to get initial info of the company
    getInitialInfo(forceReload = false) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.company_info && !forceReload) {
                this.companyLoaded.next(this.company_info);
                return;
            }
            console.debug("getInitialInfo", forceReload);
            const url = SERVER_URL + '/crm/company-info/';
            try {
                let headers = {};
                if (this.authService.USER_TOKEN)
                    headers['Authorization'] = 'token ' + this.authService.USER_TOKEN;
                let company_data = yield this.http.get(url, { headers }).toPromise();
                // Reload just necesary info
                if (this.company_info) {
                    this.company_info.home_banners = company_data.home_banners;
                    return;
                }
                this.company_info = company_data;
                this.company_info.home_page_text = this.domSanitizer.bypassSecurityTrustHtml(this.company_info.home_page_text);
                this.company_info.mobile_home_page_text = this.domSanitizer.bypassSecurityTrustHtml(this.company_info.mobile_home_page_text);
                this.company_info.secondary_home_page_text = this.domSanitizer.bypassSecurityTrustHtml(this.company_info.secondary_home_page_text);
                this.company_info.secondary_mobile_home_page_text = this.domSanitizer.bypassSecurityTrustHtml(this.company_info.secondary_mobile_home_page_text);
                this.companyLoaded.next(this.company_info);
                this.setCompanyColors();
                this.setCompanyHeadInfo();
                this.setQueryParams();
                console.debug("%c[CONFIG SERVICE] getInitialInfo() this.company_info:", "color: #004d7b", this.company_info);
            }
            catch (error) {
                console.error("[CONFIG SERVICE] (getInitialInfo) Error getting Company Info: ", error);
            }
        });
    }
    //Function to set company primary and secondary color
    setCompanyColors() {
        this.loadWebsiteColor('primary', this.company_info.primary_color);
        this.loadWebsiteColor('secondary', this.company_info.secondary_color);
    }
    /**
     * This method sets the color variables in the website
     * @param colorName Name of the color (primary, secondary, tertiary, success, warning, danger, light, medium, dark)
     * @param colorValue Value of the color (hexadecimal)
     */
    loadWebsiteColor(colorName, colorValue) {
        let colorData = this.generateColor(colorValue);
        this.document.documentElement.style.setProperty('--ion-color-' + colorName, colorData.value != null ? colorData.value : null);
        this.document.documentElement.style.setProperty('--ion-color-' + colorName + '-rgb', colorData.valueRgb != null ? colorData.valueRgb : null);
        this.document.documentElement.style.setProperty('--ion-color-' + colorName + '-contrast', colorData.contrast != null ? colorData.contrast : null);
        this.document.documentElement.style.setProperty('--ion-color-' + colorName + '-contrast-rgb', colorData.contrastRgb != null ? colorData.contrastRgb : null);
        this.document.documentElement.style.setProperty('--ion-color-' + colorName + '-shade', colorData.shade != null ? colorData.shade : null);
        this.document.documentElement.style.setProperty('--ion-color-' + colorName + '-tint', colorData.tint != null ? colorData.tint : null);
    }
    /**
     * This method generates the color variables by calculating the contrast, tint and shade of the color
     * @param value Value of the color (hexadecimal)
     * @returns
     */
    generateColor(value) {
        const color = new Color(value);
        const contrast = color.contrast();
        const tint = color.tint();
        const shade = color.shade();
        const formattedValue = value.startsWith('#') ? value : `#${value}`;
        return {
            value: formattedValue,
            valueRgb: this.rgbToString(color.rgb),
            contrast: contrast.hex,
            contrastRgb: this.rgbToString(contrast.rgb),
            tint: tint.hex,
            shade: shade.hex,
        };
    }
    rgbToString(c) {
        return `${c.r},${c.g},${c.b}`;
    }
    setQueryParams() {
        if (this.authService.queryParams)
            this.queryParams = this.authService.queryParams;
        else if (this.company_info.query_params)
            this.queryParams = this.company_info.query_params;
        console.log("QUERYPARAMS", this.queryParams);
    }
    // Function to add additional code to HTML HEAD
    setCompanyHeadInfo() {
        document.title = this.company_info.page_name;
        if (this.company_info.favicon) {
            let link = document.createElement('link');
            let oldLink = document.getElementById('dynamic-favicon');
            link.id = 'dynamic-favicon';
            link.rel = 'shortcut icon';
            link.href = this.company_info.favicon;
            if (oldLink)
                document.head.removeChild(oldLink);
            document.head.appendChild(link);
        }
        if (this.company_info.gtag) {
            console.log("TAG DEL HEAD", this.company_info.gtag);
            document.getElementsByTagName("head")[0].innerHTML += this.company_info.gtag;
            this.nodeScriptReplace(document.getElementsByClassName("customScript"));
        }
    }
    nodeScriptReplace(nodes) {
        console.log(nodes);
        for (let i = 0; i < nodes.length; i++) {
            var node = nodes[i];
            console.log("node", node);
            if (node.tagName == 'SCRIPT') {
                console.log("entra");
                node.parentNode.replaceChild(this.nodeScriptClone(node), node);
            }
        }
    }
    nodeScriptClone(node) {
        var script = document.createElement("script");
        script.text = node.innerHTML;
        var i = -1, attrs = node.attributes, attr;
        while (++i < attrs.length) {
            script.setAttribute((attr = attrs[i]).name, attr.value);
        }
        return script;
    }
    //Function to get user addresses
    getMyAddresses() {
        const url = SERVER_URL + '/crm/get_my_addresses/';
        const headers = this.authService.getAuthHeaders();
        return this.http.get(url, headers).toPromise();
    }
    //Function to get all options of the questions
    getOptions(question) {
        const url = SERVER_URL + question.options_url;
        const headers = this.authService.getAuthHeaders();
        const body = question.request_body;
        if (question.additional_body) {
            for (let field of question.additional_body) {
                body[field.name] = field.formControl.value;
            }
        }
        return this.http.post(url, body, headers).toPromise();
    }
    //Function to filter options using string 
    filterOptions(search_string, search_url) {
        const url = SERVER_URL + search_url;
        const headers = this.authService.getSimpleAuthHeaders();
        const params = {
            limit: '5',
            offset: '0',
            search: search_string
        };
        var options = { params };
        if (this.authService.isLogged)
            options = { headers, params };
        return this.http.get(url, options).toPromise();
    }
    //Function to create address
    addAddress(addressCreated) {
        const url = SERVER_URL + '/crm/create_address/';
        const headers = this.authService.getAuthHeaders();
        const body = {
            info: addressCreated.info,
            servientrega_city: addressCreated.servientrega_city.city.id,
            cellphone: addressCreated.cellphone,
            document: addressCreated.document,
            additional_info: addressCreated.additional_info,
            person_name: addressCreated.person_name,
            neighborhood: addressCreated.neighborhood,
            is_active: true
        };
        return this.http.post(url, body, headers).toPromise();
    }
    //Function to set new active address
    setActiveAddress(address_id) {
        const url = SERVER_URL + '/crm/set_active_address/';
        const headers = this.authService.getAuthHeaders();
        const body = {
            address_id
        };
        console.log('BODDYYYY', body);
        return this.http.post(url, body, headers).toPromise();
    }
    //Function to delete the address by id
    deleteAddress(address_id) {
        const url = SERVER_URL + '/crm/delete_address/';
        const headers = this.authService.getAuthHeaders();
        const body = {
            address_id
        };
        return this.http.post(url, body, headers).toPromise();
    }
    points_to_money(points) {
        let valueInMoney = points * this.company_info.currency_value;
        console.debug("points_to_money", points, this.company_info.currency_value, valueInMoney);
        return valueInMoney;
    }
    // Function to cast price to points
    price_to_points(product, price) {
        // Value calculated in points
        let value_in_points = this.price_by_company(product, price) / this.company_info.currency_value;
        // Value in points rounded to the next integer
        return Math.ceil(value_in_points);
    }
    price_by_company(product, price) {
        if (!product.hasOwnProperty('profit'))
            product.profit = 0;
        if (!product.hasOwnProperty('delivery_price'))
            product.delivery_price = 0;
        let total_profit = (price * product.profit / 100);
        // if (product.taxes && (product.brand_id || product.is_wallet)) total_profit += (total_profit * product.taxes) / 100;
        return price + total_profit + product.delivery_price;
    }
    fixCustomProduct(product, custom_value) {
        product.custom_redeem_value = custom_value;
        product.name = product.name.replace(/\s\$.*/, '');
        product.name += " " + this.formatCurrency(custom_value);
        product.price = this.price_to_points(product, custom_value);
        product.custom_price_cash = this.price_by_company(product, custom_value);
        if (product.discount > 0) {
            var index = product.discount_value.indexOf('Dcto');
            if (index != -1) {
                var discount_percentage = product.discount_value.replace(/% Dcto/, "");
                product.discount = product.price * discount_percentage / 100;
            }
        }
        return product;
    }
    formatCurrency(value) {
        const options = {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        };
        const numberFormat = new Intl.NumberFormat('en-US', options);
        return numberFormat.format(value);
    }
    //Function to optimize Image
    resizeImage(originalImg, newWidth, newHeight) {
        return new Promise(function (resolve) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var img = document.createElement('img');
                img.onload = function () {
                    var canvas = document.createElement('canvas');
                    var ctx = canvas.getContext('2d');
                    var iw = img.width;
                    var ih = img.height;
                    var scale = Math.min((newWidth / iw), (newHeight / ih));
                    if (newWidth > iw || newHeight > ih)
                        scale = 1;
                    var iwScaled = iw * scale;
                    var ihScaled = ih * scale;
                    canvas.width = iwScaled;
                    canvas.height = ihScaled;
                    if (img.width < newWidth || img.height < newHeight)
                        ctx.drawImage(img, 0, 0, img.width, img.height);
                    else
                        ctx.drawImage(img, 0, 0, iwScaled, ihScaled);
                    var dataURI = canvas.toDataURL('image/jpeg', 0.9);
                    resolve(dataURI);
                };
                img.src = originalImg;
            });
        });
    }
    getPosts(limit, offset) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = SERVER_URL + '/social/posts/';
            const params = {
                limit,
                offset,
            };
            const headers = yield this.authService.getSimpleAuthHeaders();
            return this.http.get(url, { params, headers }).toPromise();
        });
    }
    createPostImage(image, post) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = SERVER_URL + '/social/post-image/';
            const body = {
                image,
                post
            };
            const headers = yield this.authService.getAuthHeaders();
            return this.http.post(url, body, headers).toPromise();
        });
    }
    createPost(text, player_id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = SERVER_URL + '/social/posts/';
            const body = {
                text,
                player: player_id
            };
            const headers = yield this.authService.getAuthHeaders();
            return this.http.post(url, body, headers).toPromise();
        });
    }
    createReaction(player, post, type) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = SERVER_URL + '/social/reactions/';
            const body = {
                player,
                post,
                type
            };
            const headers = yield this.authService.getAuthHeaders();
            return this.http.post(url, body, headers).toPromise();
        });
    }
    deleteReaction(player, post, type) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.userHasAlreadyPosted = false;
            const url = SERVER_URL + '/social/delete_reaction/';
            const body = {
                player,
                post,
                type
            };
            const headers = yield this.authService.getAuthHeaders();
            return this.http.post(url, body, headers).toPromise();
        });
    }
    createComment(text, player, post) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = SERVER_URL + '/social/comments/';
            const body = {
                text,
                is_deleted: false,
                post,
                player,
            };
            const headers = yield this.authService.getAuthHeaders();
            return this.http.post(url, body, headers).toPromise();
        });
    }
    getComments(post, limit, offset) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = SERVER_URL + '/social/comments/post/' + post;
            const params = {
                limit,
                offset,
            };
            const headers = yield this.authService.getSimpleAuthHeaders();
            return this.http.get(url, { params, headers }).toPromise();
        });
    }
    deleteComment(commentId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = SERVER_URL + '/social/comments/' + commentId + '/';
            const headers = yield this.authService.getSimpleAuthHeaders();
            return this.http.delete(url, { headers }).toPromise();
        });
    }
    updateComment(player, commentId, commentText) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = SERVER_URL + '/social/comments/' + commentId + '/';
            const body = {
                player: player,
                id: commentId,
                text: commentText
            };
            const headers = yield this.authService.getAuthHeaders();
            return this.http.put(url, body, headers).toPromise();
        });
    }
    humanFileSize(bytes) {
        var thresh = 1000;
        if (Math.abs(bytes) < thresh) {
            return bytes + ' B';
        }
        var units = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        var u = -1;
        do {
            bytes /= thresh;
            ++u;
        } while (Math.abs(bytes) >= thresh && u < units.length - 1);
        return bytes.toFixed(1) + ' ' + units[u];
    }
    setCategory(category) {
        this.category = category;
    }
    getCategory() {
        return this.category;
    }
    hasSequenceInRow(str) {
        let sequence = 0;
        let numbers = '0123456789';
        let numbersBack = '9876543210';
        let letters = 'abcdefghijklmnopqrstuvwxyz';
        let lettersBack = 'zyxwvutsrqponmlkjihgfedcba';
        let newSetStr = [];
        if (str) {
            newSetStr = str.split('');
        }
        for (let i = 0; i < newSetStr.length; i++) {
            if ((numbers.includes(newSetStr[i] + newSetStr[i + 1] + newSetStr[i + 2]))
                || (letters.includes(newSetStr[i] + newSetStr[i + 1] + newSetStr[i + 2]))
                || (numbersBack.includes(newSetStr[i] + newSetStr[i + 1] + newSetStr[i + 2]))
                || (lettersBack.includes(newSetStr[i] + newSetStr[i + 1] + newSetStr[i + 2]))) {
                sequence++;
            }
            if (sequence >= 1) {
                return true;
            }
        }
        return false;
    }
    containsUppercase(str) {
        return /[A-Z]/.test(str);
    }
    containsLowercase(str) {
        return /[a-z]/.test(str);
    }
    containsNumber(str) {
        return /[0-9]/.test(str);
    }
    hasRepeatedInRow(str) {
        let repeated = 0;
        let newSetStr = [];
        if (str) {
            newSetStr = str.split('');
        }
        for (let i = 0; i < newSetStr.length; i++) {
            if (newSetStr[i] === newSetStr[i + 1]
                && newSetStr[i] === newSetStr[i + 2]) {
                repeated++;
            }
            if (repeated >= 1) {
                return true;
            }
        }
        return false;
    }
    notifyCommentCreated() {
        this.commentCreatedSource.next();
    }
    notifyReactionDeleted(reaction, postId) {
        let obj = {
            postId,
            reaction
        };
        this.reactionDeletedSource.next(obj);
    }
    goToVariant(variantDomain) {
        let redirectUrl = variantDomain + "/inicio?tk=" + this.authService.USER_TOKEN;
        console.debug("goToVariant", redirectUrl);
        window.location.href = redirectUrl;
    }
    redirectUrl() {
        const api_url = SERVER_URL + '/crm/generate_link_with_token/';
        const headers = this.authService.getSimpleAuthHeaders();
        return this.http.get(api_url, { headers });
    }
}
ConfigService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ConfigService_Factory() { return new ConfigService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.DOCUMENT), i0.ɵɵinject(i3.AuthService), i0.ɵɵinject(i4.DomSanitizer)); }, token: ConfigService, providedIn: "root" });
